<div [formGroup]="form" class="margin-bottom-small">
  <input type="hidden" [formControlName]="question.key" [id]="question.key" />
  <div *ngIf="question.data && question.data.length" class="margin-bottom-medium">
    <open-raptor-repeater-summary [question]="question" [form]="form" [editing]="editing" (save)="save()"></open-raptor-repeater-summary>
  </div>

  <div *ngIf="editing && repeaterQuestions.length" class="raptor-repeater-questions-panel">
    <div *ngFor="let row of repeaterQuestions" class="raptor-repeater-questions grid">
      <div
        *ngFor="let field of row"
        [class]="raptorDataService.columnLayoutClass(columns, field)"
      >
        <open-raptor-question *ngIf="field.type && showQuestion(field)" [question]="field" [form]="form" [submitted]="submitted"></open-raptor-question>
        <open-raptor-component *ngIf="field.component" [form]="form" [type]="field.component" [config]="field"></open-raptor-component>
      </div>
    </div>
  </div>

  <div *ngIf="editing">
    <button mat-stroked-button color="secondary" type="button" class="margin-right-small" (click)="save()" [disabled]="!repeaterValid()">Save</button>
    <button mat-button type="button" class="margin-right-small repeater-cancel" (click)="cancel()" *ngIf="question.data && question.data.length > 0">Cancel</button>
  </div>
  <div *ngIf="!editing">
    <button mat-stroked-button color="secondary" type="button" class="margin-right-small" (click)="add()" [disabled]="maxItems()">Add</button>
  </div>
</div>